<nav id="mobile-menu-container" [ngClass]="{'fixed': navIsFixed}">
  @if (haveHomeLink) {
    <a routerLink="{{ rootUrl }}"
       [ngClass]="{'active': activated(rootUrl)}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Homepage', 'eventAction': 'Click', 'eventLabel': 'Homepage', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fas fa-home custom-home"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.HOME'"></span>
        </div>
      </div>
    </a>
  }

  @if (noContentLink()) {
    <a routerLink="/no-content"
       [routerLinkActive]="['active']" #rla="routerLinkActive" [ngClass]="{'active': activated('/no-content')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Sports', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="fal fa-list-ul"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.POOLS'"></span>
        </div>
      </div>
    </a>
  }

  @if (hasSportsMenuItem()) {
    <a routerLink="/pools/sports" (click)="setDisplayState('SPORTS')"
       [routerLinkActive]="['active']"  #rla="routerLinkActive" [ngClass]="{'active': activated('/pools/sports')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Sports', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon far fa-futbol"></i>
        </div>
        <div class="mobile-nav-label">
          <span  [transloco]="'contentType.SPORTS'"></span>
        </div>
      </div>
    </a>
  }

  @if (hasRacingMenuItem()) {
    <a routerLink="/pools/racing" (click)="setDisplayState('RACING')"
       [routerLinkActive]="['active']"  #rla="routerLinkActive" [ngClass]="{'active': activated('/pools/racing')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Racing', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fak fa-racing"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'contentType.RACING'"></span>
        </div>
      </div>
    </a>
  }

  @if (hasFantasyMenuItem()) {
    <a routerLink="/pools/fantasy" (click)="setDisplayState('FANTASY')"
       [routerLinkActive]="['active']"  #rla="routerLinkActive" [ngClass]="{'active': activated('/pools/fantasy')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Fantasy', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 33 32" fill="none">
              <path d="M16.8332 21.9508C8.23317 21.9508 6.21317 10.1608 6.24317 3.37084C6.24317 2.74084 6.66317 2.20084 7.26317 2.04084C10.7432 1.13084 17.9932 0.230841 26.2832 2.07084C26.9332 2.22084 27.4032 2.79084 27.4032 3.46084C27.4132 10.2608 25.3732 21.9508 16.8232 21.9508H16.8332ZM16.8332 21.9508V27.2308M16.8332 27.2308H13.5432C12.8232 27.2308 12.2032 27.7408 12.0632 28.4408L11.5532 31.0008M16.8332 27.2308H20.1232C20.8432 27.2308 21.4632 27.7408 21.6032 28.4408L22.1132 31.0008M6.27317 5.35084L2.58317 7.20084C2.07317 7.46084 1.75317 7.98084 1.75317 8.55084V12.0108C1.75317 12.5608 2.05317 13.0608 2.53317 13.3308L8.54317 16.6708M27.3932 5.35084L31.0832 7.20084C31.5932 7.46084 31.9132 7.98084 31.9132 8.55084V12.0108C31.9132 12.5608 31.6132 13.0608 31.1332 13.3308L25.1232 16.6708M7.78317 31.0008H25.8932" stroke="#ababab" stroke-width="2" stroke-linecap="round"/>
              <path d="M17.0432 5.51107L17.3532 6.56107C17.5632 7.27107 17.9432 7.91107 18.4632 8.43107C18.9832 8.95107 19.6332 9.33107 20.3332 9.54107L21.3832 9.85107C21.5932 9.91107 21.5932 10.2111 21.3832 10.2711L20.3232 10.5811C19.6132 10.7911 18.9732 11.1711 18.4532 11.6911C17.9332 12.2111 17.5532 12.8611 17.3432 13.5611L17.0332 14.6111C16.9732 14.8211 16.6732 14.8211 16.6132 14.6111L16.3032 13.5511C16.0932 12.8411 15.7132 12.2011 15.1932 11.6811C14.6732 11.1611 14.0232 10.7811 13.3232 10.5711L12.2732 10.2611C12.0632 10.2011 12.0632 9.90107 12.2732 9.84107L13.3232 9.53107C14.0332 9.32107 14.6732 8.94107 15.1932 8.42107C15.7132 7.90107 16.0932 7.25107 16.3032 6.55107L16.6132 5.50107C16.6132 5.50107 16.6532 5.41107 16.6932 5.39107C16.7332 5.36107 16.7732 5.35107 16.8232 5.35107C16.8732 5.35107 16.9132 5.37107 16.9532 5.39107C16.9932 5.42107 17.0232 5.46107 17.0332 5.50107L17.0432 5.51107Z" fill="#ababab"/>
            </svg>
          </div>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'contentType.FANTASY'"></span>
        </div>
      </div>
    </a>
  }

  @if (hasGenericMenuItem()) {
    <a routerLink="/pools/generic" (click)="setDisplayState('GENERIC')"
       [routerLinkActive]="['active']"  #rla="routerLinkActive" [ngClass]="{'active': activated('/pools/generic')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Generic', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 33 32" fill="none">
              <path d="M16.8332 21.9508C8.23317 21.9508 6.21317 10.1608 6.24317 3.37084C6.24317 2.74084 6.66317 2.20084 7.26317 2.04084C10.7432 1.13084 17.9932 0.230841 26.2832 2.07084C26.9332 2.22084 27.4032 2.79084 27.4032 3.46084C27.4132 10.2608 25.3732 21.9508 16.8232 21.9508H16.8332ZM16.8332 21.9508V27.2308M16.8332 27.2308H13.5432C12.8232 27.2308 12.2032 27.7408 12.0632 28.4408L11.5532 31.0008M16.8332 27.2308H20.1232C20.8432 27.2308 21.4632 27.7408 21.6032 28.4408L22.1132 31.0008M6.27317 5.35084L2.58317 7.20084C2.07317 7.46084 1.75317 7.98084 1.75317 8.55084V12.0108C1.75317 12.5608 2.05317 13.0608 2.53317 13.3308L8.54317 16.6708M27.3932 5.35084L31.0832 7.20084C31.5932 7.46084 31.9132 7.98084 31.9132 8.55084V12.0108C31.9132 12.5608 31.6132 13.0608 31.1332 13.3308L25.1232 16.6708M7.78317 31.0008H25.8932" stroke="#ababab" stroke-width="2" stroke-linecap="round"/>
              <path d="M17.0432 5.51107L17.3532 6.56107C17.5632 7.27107 17.9432 7.91107 18.4632 8.43107C18.9832 8.95107 19.6332 9.33107 20.3332 9.54107L21.3832 9.85107C21.5932 9.91107 21.5932 10.2111 21.3832 10.2711L20.3232 10.5811C19.6132 10.7911 18.9732 11.1711 18.4532 11.6911C17.9332 12.2111 17.5532 12.8611 17.3432 13.5611L17.0332 14.6111C16.9732 14.8211 16.6732 14.8211 16.6132 14.6111L16.3032 13.5511C16.0932 12.8411 15.7132 12.2011 15.1932 11.6811C14.6732 11.1611 14.0232 10.7811 13.3232 10.5711L12.2732 10.2611C12.0632 10.2011 12.0632 9.90107 12.2732 9.84107L13.3232 9.53107C14.0332 9.32107 14.6732 8.94107 15.1932 8.42107C15.7132 7.90107 16.0932 7.25107 16.3032 6.55107L16.6132 5.50107C16.6132 5.50107 16.6532 5.41107 16.6932 5.39107C16.7332 5.36107 16.7732 5.35107 16.8232 5.35107C16.8732 5.35107 16.9132 5.37107 16.9532 5.39107C16.9932 5.42107 17.0232 5.46107 17.0332 5.50107L17.0432 5.51107Z" fill="#ababab"/>
            </svg>
          </div>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'contentType.GENERIC'"></span>
        </div>
      </div>
    </a>
  }

  @if (enableFreeplay && !hideFreeplayTab && isAgeVerified()) {
    <a class="freeplay" routerLink="/freeplay"
       [routerLinkActive]="['active']"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Freeplay', 'eventAction': 'Click', 'eventLabel': 'List', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fak fa-freeplay"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'poolsMenu.FREEPLAY'"></span>
        </div>
        @if (freeplays() && freeplays() > 0 && isAgeVerified()) {
          <span class="fp-badge">{{freeplays()}}</span>
        }
      </div>
    </a>
  }

  @if (syndicatesEnabled && !hideSyndicatesTab) {
    <a (click)="resetSyndicateList()" routerLink="/syndicates"
       [routerLinkActive]="['active']" #rla="routerLinkActive" [ngClass]="{'active': activated('/syndicates')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Syndicates', 'eventAction': 'Click', 'eventLabel': 'All', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fas fa-user-friends"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.SYNDICATES'"></span>
        </div>
      </div>
    </a>
  }

  @if (isLoggedIn() && !isCashOut) {
    <a class="tickets" (click)="resetTicketFilter()" routerLink="/tickets"
       [routerLinkActive]="['active']" [ngClass]="{'active': activated('/tickets')}"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Tickets', 'eventAction': 'Click', 'eventLabel': 'List', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fas fa-ticket-alt"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.TICKETS'"></span>
        </div>
        @if (isLoggedIn() && !isCashOut && haveGroupTickets()) {
          <a class="gt-badge" routerLink="/tickets/list/group" [queryParams]="{show: 'invitations'}">{{groupTicketInvites()}}</a>
        }
      </div>
    </a>
  }

  @if (isLoggedIn() && isCashOut) {
    <a (click)="resetTicketFilter()" routerLink="/tickets"
       [routerLinkActive]="['active']"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'Tickets', 'eventAction': 'Click', 'eventLabel': 'Unauth', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fas fa-ticket-alt"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.TICKETS'"></span>
        </div>
      </div>
    </a>
  }

  @if (enableUnauthCashout) {
    <a routerLink="/tickets/unauth"
       [routerLinkActive]="['active']"
       [track]="{event: 'micrositeEvent', 'eventCategory': 'CashOut', 'eventAction': 'Click', 'eventLabel': 'Unauth', isTracking: true}">
      <div class="mobile-nav-item">
        <div class="mobile-nav-icon">
          <i class="icon fas fa-ticket-alt"></i>
        </div>
        <div class="mobile-nav-label">
          <span [transloco]="'menu.CASHOUT'"></span>
        </div>
      </div>
    </a>
  }

  <a routerLink="/help"  class="help-menu-item"
     [routerLinkActive]="['active']"
     [track]="{event: 'micrositeEvent', 'eventCategory': 'Help', 'eventAction': 'Click', 'eventLabel': '', isTracking: true}">
    <div class="mobile-nav-item">
      <div class="mobile-nav-icon">
        <i class="icon far fa-question-circle"></i>
      </div>
      <div class="mobile-nav-label">
        <strong [transloco]="'menu.HELP'"></strong>
      </div>
    </div>
  </a>
</nav>
